import { settings } from "./settings"
import { Keyboard } from "@capacitor/keyboard"

let keyboardHeight = 0
let currentScrollOffset = 0

export function setupKeyboard() {
  if (!settings.IS_NATIVE_APP) return
  if (settings.IS_IOS) {
    return
  }

  console.log("Using Android keyboard height adjustments")

  Keyboard.addListener("keyboardWillShow", (event) => {
    console.log("keyboardWillShow", event)
    keyboardHeight = event.keyboardHeight || 300

    // Get the currently focused element
    const activeElement = document.activeElement as HTMLElement

    if (activeElement && isFormField(activeElement)) {
      // Add keyboard height as bottom padding to the viewport
      document.documentElement.style.setProperty("--keyboard-height", `${keyboardHeight}px`)
      document.body.style.paddingBottom = `${keyboardHeight}px`

      // Wait for the DOM to update, then scroll the field into view
      setTimeout(() => {
        scrollFieldIntoView(activeElement)
      }, 150)
    }
  })

  Keyboard.addListener("keyboardDidShow", (event) => {
    console.log("keyboardDidShow", event)

    const activeElement = document.activeElement as HTMLElement
    if (activeElement && isFormField(activeElement)) {
      // Double-check scroll position after keyboard is fully shown
      setTimeout(() => {
        scrollFieldIntoView(activeElement)
      }, 100)
    }
  })

  Keyboard.addListener("keyboardWillHide", () => {
    console.log("keyboardWillHide")
    keyboardHeight = 0
    currentScrollOffset = 0

    // Remove keyboard height styling
    document.documentElement.style.removeProperty("--keyboard-height")
    document.body.style.paddingBottom = "0px"
  })

  // Handle focus events to ensure proper scrolling
  document.addEventListener("focusin", (event) => {
    const target = event.target as HTMLElement
    if (isFormField(target) && keyboardHeight > 0) {
      setTimeout(() => {
        scrollFieldIntoView(target)
      }, 100)
    }
  })
}

function isFormField(element: HTMLElement): boolean {
  return (
    element instanceof HTMLInputElement ||
    element instanceof HTMLTextAreaElement ||
    element instanceof HTMLSelectElement ||
    element.getAttribute("contenteditable") === "true" ||
    element.getAttribute("role") === "textbox"
  )
}

function scrollFieldIntoView(element: HTMLElement) {
  if (!element) return

  const rect = element.getBoundingClientRect()
  const windowHeight = window.innerHeight
  const availableHeight = windowHeight - keyboardHeight

  // Calculate if the field is hidden behind the keyboard
  const fieldBottom = rect.bottom
  const fieldTop = rect.top

  // If the field is below the available space, scroll it into view
  if (fieldBottom > availableHeight) {
    const scrollAmount = fieldBottom - availableHeight + 20 // 20px padding
    currentScrollOffset += scrollAmount

    // Use smooth scrolling
    window.scrollBy({
      top: scrollAmount,
      behavior: "smooth"
    })
  }
  // If the field is above the viewport, scroll it down
  else if (fieldTop < 0) {
    const scrollAmount = fieldTop - 20 // 20px padding from top
    currentScrollOffset += scrollAmount

    window.scrollBy({
      top: scrollAmount,
      behavior: "smooth"
    })
  }
}
